import {customElement} from "solid-element";
import {translations} from "../../services/context";
import { Show, createSignal, For, createEffect, onMount, on, onCleanup } from "solid-js";
import { countryCodes } from "./countryCodes";

import { sendRequest } from "../../services/office-api"

import CreateImg from './img/welcome-modal/create.svg';
import DomainImg from './img/welcome-modal/domain.svg';
import UpgradeImg from './img/welcome-modal/upgrade.svg';

const urlDomainRegistry = process.env.DOMAIN_REGISTRY+'/api/v1/';
const urlAfterPaymentPage = process.env.OFFICE+'/us/office?domain-purchase=funnel-ty';
const urlOffice = process.env.OFFICE;
const tokenCreateUser = "pIz8GpaV0cZvGzmOLa5zRSXnUR2hXtlzW3mOPrNPbP8JnLTOWjG%2BCgVGqGx0BnA70OZYzIoKSVXwBBjOTzYdNtFt4qxvwxU07oIMtyA9SiFAUOeXSbILkqTLFdW91hqohELwnyAs2KW1dlJBNz08d1aCO3Rx4Ua0c1%2BtIQEWDUyVpoWjBP26O9asP9GsZwkVKsXCaPpBjQbqnm2iO78rDrwgdqBO%2FHhphdFGWpwfejlnERweLi9tzGBm";

const [step, setStep] = createSignal(1);
const [loading, setLoading] = createSignal(false);
const [searchFirstDomainValue, setSearchFirstDomainValue] = createSignal(null);
const [domainsList, setDomainsList] = createSignal([]);
const [servicesList, setServicesList] = createSignal({});
const [usersRegistrationData, setUsersRegistrationData] = createSignal([]);
const [selectedDomain, setSelectedDomain] = createSignal(null);
const [errorMessage, setErrorMessage] = createSignal(null);
const [paymentLink, setPaymentLink] = createSignal(null);
const [urlParameters, setUrlParameters] = createSignal(null);
const [urlHash, setUrlHash] = createSignal(null);
const [selectedPeriod, setSelectedPeriod] = createSignal(1);
const [selectedUserOption, setSelectedUserOption] = createSignal(null);
const [orderHash, setOrderHash] = createSignal(null);
const [extendedAttributesHash, setExtendedAttributesHash] = createSignal(null);
const [extendedAttributesQuestions, setExtendedAttributesQuestions] = createSignal([]);
const [extendedAttributesForm, setExtendedAttributesForm] = createSignal({});
const [coupon25free, setCoupon25free] = createSignal(false);
const [useCoupon, setUseCoupon] = createSignal(false);
const [urlParams, setUrlParams] = createSignal({
    domainPurchase: null,
    term: null,
    domain: null,
    period: null,
    privacyProtection: null,
});
const [showToast, setShowToast] = createSignal(false);
const [toastData, setToastData] = createSignal({
  type: 'ba-success',
  message: translations['toolkit-success-upload'] || 'Success',
  url: null
});
const [registrationDataForm, setRegistrationDataForm] = createSignal({
    hash: null,
    first_name: null,
    last_name: null,
    address: null,
    address_complement: null,
    city: null,
    state_province: null,
    state_province_choice: 'STATE',
    postal_code: null,
    country: null,
    email: null,
    country_code: 1,
    phone: null,
    organization: null,
    job_title: null,
    accept_terms: false,
    accept_ba_terms: false,
    iubenda_consent: null
});

customElement("builderall-enom", {tool: "", token: "", show: false, step: null, isfromhomepage: false, domain: null}, props => {
    createEffect(() => {
        if(props.isfromhomepage && props.domain){
            setStep(2);
            setSearchFirstDomainValue(props.domain);
            validateSearch();
            props.domain = null;
        }
    });

    createEffect(on( () => props.show, async (v) => {
      if (v && props.token)
      {
        setLoading(true)
        await checkIfCouponIsUsed('BEYOND')
        await checkIfCouponIsUsed('BEY8ND')
        setLoading(false)
      }
    }));

    let registrationForm;
    const setRegistrationForm = (el) => {
        if (el) {
            registrationForm = el;
        }
    };

    let buttonRegistrationForm;
    const setButtonRegistrationForm = (el) => {
        if (el) {
            buttonRegistrationForm = el;
        }
    };

    if(props.isfromhomepage){
        // get url parameters
        var stringParameters = window.location.search;
        var stringHash = window.location.hash;

        if (stringHash.charAt(0) === '#') {
            stringHash = stringHash.slice(1);
            setUrlHash(stringHash)
        }

        if(stringParameters.charAt(0) === '?') {
            stringParameters = stringParameters.slice(1);
            setUrlParameters(stringParameters);
        }

        let userData = JSON.parse(localStorage.getItem("builderall-appshell--resources"));
        var userLang = !userData || !userData.user.lang ? 'us' : !userData.user.lang.split("_")[1] ? 'us' : userData.user.lang.split("_")[1];
        userLang = userLang.toLowerCase();
    }

    if(props.step == 'thank-you'){
        setStep(6);
    }

    // Methods
    const alertMsg = (type, message, url = null) => {
      setToastData({
        type: type,
        message: message,
        url: url
      })

      setShowToast(true)

      const timer = setTimeout(closeToast, 10000)

      onCleanup(() => clearTimeout(timer))
    }

    const closeToast = () => {
      setShowToast(false)
    }

    const closeModal = () => {
        document.querySelector('builderall-enom').setAttribute('show', 'false');
        resetAllElements();

        const customEvent = new CustomEvent("close-modal", {
            detail: { show: false },
        });
        window.dispatchEvent(customEvent);
    }

    const verifyToCloseModal = (e) => {
        const el = e.target.getAttribute('class');
        if(el == "modal-backdrop enom-modal")
        {
            closeModal();
        }
    }

    const changeSearchDomainInput = (event) => {
        setSearchFirstDomainValue(event.target.value);
        const newValue = event.target.value.replace(/\s/g, "");
        setSearchFirstDomainValue(newValue);
    };

    const changeRegistrationInput = (event, index) => {
        var newValue = event.target.value;
        if(index == 'accept_terms'){
            newValue = !registrationDataForm().accept_terms;
        }
        if(index == 'accept_ba_terms'){
            newValue = !registrationDataForm().accept_ba_terms;
        }
        setRegistrationDataForm((prevData) => {
            return { ...prevData, [index]: newValue };
        });
    };

    function resetAllElements(){
        setStep(1);
        setLoading(false);
        setSearchFirstDomainValue(null);
        setDomainsList([]);
        setServicesList({});
        setUsersRegistrationData([]);
        setSelectedDomain(null);
        setErrorMessage(null);
        setPaymentLink(null);
        setUrlParameters(null);
        setUrlHash(null);
        setSelectedPeriod(1);
        setSelectedUserOption(null);
        setOrderHash(null);
        setExtendedAttributesHash(null);
        setExtendedAttributesQuestions([]);
        setExtendedAttributesForm({});
        setUrlParams({
            domainPurchase: null,
            term: null,
            domain: null,
            period: null,
            privacyProtection: null,
        });
        resetRegistrationData();
    }

    function resetRegistrationData(){
        const data = JSON.parse(localStorage.getItem("builderall-appshell--resources"));
        const first_name = !data.user.name ? null : data.user.name.split(" ")[0];
        const last_name = !data.user.name ? null : !data.user.name.split(" ")[1] ? null : data.user.name.split(" ")[1];
        const email = !data.user.email ? null : data.user.email;
        const country = !data.user.lang ? null : !data.user.lang.split("_")[1] ? null : data.user.lang.split("_")[1];
        const cc_country = !data.user.lang ? null : !data.user.lang.split("_")[1] ? null : data.user.lang.split("_")[1];
        const country_code = !cc_country ? 1 : !countryCodes.find(x => x.country == cc_country) ? 1 : countryCodes.find(x => x.country == cc_country).code;

        setRegistrationDataForm({
            hash: null,
            first_name: first_name,
            last_name: last_name,
            address: null,
            address_complement: null,
            city: null,
            state_province: null,
            state_province_choice: 'STATE',
            postal_code: null,
            country: country.toLowerCase(),
            email: email,
            country_code: !country_code ? 1 : parseInt(country_code),
            phone: null,
            organization: null,
            job_title: null,
            accept_terms: false,
            accept_ba_terms: false,
            iubenda_consent: null
        });
    }

    function calcTotalValue() {
        return selectedDomain().privacy_protection ? ((selectedDomain().price + servicesList().price) * selectedPeriod()).toFixed(2) : (selectedDomain().price * selectedPeriod()).toFixed(2);
    }

    function showDomainDetails(domain : string) {
        const updatedDomainsList = domainsList().map(x => ({
            ...x,
            show_details: x.domain == domain,
        }));

        setSelectedDomain(updatedDomainsList.find(x => x.show_details));

        setDomainsList(updatedDomainsList);
    }

    function setValueEA(data, index){
        setExtendedAttributesForm((prevData) => {
            return { ...prevData, [index]: data };
        });
    }

    function handleCheckboxChange(domain : string){
        const newPrivacyStatus = !selectedDomain().privacy_protection;

        const updatedDomainsList = domainsList().map(x => {
            if (x.domain === domain) {
              return {
                ...x,
                privacy_protection: newPrivacyStatus,
              };
            }
            return x;
          });

        setSelectedDomain({...selectedDomain(), privacy_protection: newPrivacyStatus});

        setDomainsList(updatedDomainsList);
    }

    function handleEnterKey(event) {
        if(event.key === "Enter"){
            validateSearch();
        }
    }

    function validateSearch(){
        if(!searchFirstDomainValue() == false){
            setStep(2);
            searchDomain();
        }
    }

    function validateToExtendedAttributes(){
        if(selectedDomain().extended_attributes){
            getExtendedAttributesData();
        } else {
            if(props.isfromhomepage){
                window.open(paymentLink(), '_blank');
                setTimeout(() => {
                    setStep(0);
                }, 3000);
            } else {
                getUsersRegistrationData();
            }
        }
    }

    function validateBackToExtendedAttributes(){
        if(selectedDomain().extended_attributes){
            setStep(3);
        } else {
            setStep(2);
        }
    }

    function validateBackToRegistrationDataList(){
        if(props.isfromhomepage){
            setStep(2);
        } else {
            if(usersRegistrationData().length > 0){
                setStep(4);
            } else {
                validateBackToExtendedAttributes();
            }
        }
    }

    function validateRegistrationDataForm(evt){
        evt.preventDefault();
        if(props.isfromhomepage){
            defineIubenda();
        } else {
            if(!registrationDataForm().state_province || registrationDataForm().state_province.length > 2){
                return;
            }

            registrationDataForm().phone = registrationDataForm().country_code + registrationDataForm().phone;

            if(registrationDataForm().hash == null){
                postRegistrationData();
            } else {
                putRegistrationData();
            }
        }
    }

    function validateExtendedAttributesForm(evt){
        evt.preventDefault();
        postExtendedAttributesData();
    }

    function editRegistrationData(data){
        setRegistrationDataForm(data);
        setStep(5);
    }

    function fixCreatedAtDate(created_at){
        const data = new Date(created_at);

        const month = (data.getMonth() + 1).toString().padStart(2, '0');
        const day = data.getDate().toString().padStart(2, '0');
        const year = data.getFullYear();

        return `${month}/${day}/${year}`;
    }

    function defineSelectedUser(data){
        data.accept_terms = true;
        setSelectedUserOption(data);
    }

    function defineOrderData(){
        var data = {
            title: `Domain Purchase - ${props.tool || 'Home'}`,
            items: [
                {
                    item: selectedDomain().domain,
                    operation: "PURCHASE",
                    type: "DOMAIN",
                    period: selectedPeriod(),
                    period_type: "YEAR"
                }
            ]
        };

        if(selectedDomain().privacy_protection){
            data.items.push({
                item: selectedDomain().domain,
                operation: "PURCHASE",
                type: "ID_PROTECTION",
                period: selectedPeriod(),
                period_type: "YEAR"
            })
        }

        return data;
    }

    function defineExtendedAttributesData(){
        var data = {
            attributes: []
        };

        for (const key in extendedAttributesForm()){
            if(extendedAttributesForm()[key]){
                data.attributes.push({
                    name: key,
                    value: extendedAttributesForm()[key]
                })
            }
        }

        return data;
    }

    async function searchDomain(domain: null){
        setLoading(true);
        setDomainsList([]);
        setServicesList({});

        let couponQuery: string = ''

        if (props.token) {
            await checkIfCouponIsUsed('BEYOND')
            await checkIfCouponIsUsed('BEY8ND')
        }

        if (coupon25free() && useCoupon())
        {
          couponQuery = '&max_price=25'
        }

        fetch(`${urlDomainRegistry}domain/purchase/search?term=${searchFirstDomainValue()}&max=7${couponQuery}`, {
            headers: new Headers({
                'Authorization': `Bearer ${props.token}`,
            }),
        })
            .then(r => r.json())
            .then(response => {
                setDomainsList(response.data.domains);
                setServicesList(response.data.services);
            })
            .catch(e => {
                console.error('Error get domains: ',e);
            })
            .finally(() => {
                setLoading(false);
                isEmpty(domain) ? null : showDomainDetails(domain)

                if (!isEmpty(domain) && !isEmpty(urlParams().privacyProtection) && urlParams().privacyProtection === '1') {
                    handleCheckboxChange(domain)
                }
            })
    }

    function getExtendedAttributesData(){
        setLoading(true);
        fetch(`${urlDomainRegistry}order/${orderHash()}/item/${extendedAttributesHash()}/extended-attributes`, {
            headers: new Headers({
                'Authorization': `Bearer ${props.token}`,
            }),
        })
            .then(r => r.json())
            .then(response => {
                if(response.success){
                    setStep(3);
                    setExtendedAttributesQuestions(response.data)
                }
            })
            .catch(e => {
                console.error('Error get extended attributes data: ',e);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    function getUsersRegistrationData(){
        setLoading(true);
        fetch(`${urlDomainRegistry}registrant`, {
            headers: new Headers({
                'Authorization': `Bearer ${props.token}`,
            }),
        })
            .then(r => r.json())
            .then(response => {
                if(response.data.length == 0){
                    resetRegistrationData();
                    setStep(5);
                } else {
                    setStep(4);
                    const newData = response.data;
                    newData.forEach(x => {
                        x.country_code = x.phone.split("-")[0];
                        x.phone = x.phone.split("-")[1];
                        if(x.is_default){
                            setSelectedUserOption(x);
                        }
                    })
                    setUsersRegistrationData(newData);
                }
            })
            .catch(e => {
                console.error('Error get registration data: ',e);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    async function checkIfCouponIsUsed(coupon: string){
      try {
        setLoading(true);

        if(sessionStorage.getItem('used-coupon-25free'))
        {
          setCoupon25free(false)
          return
        }

        const requestInit: RequestInit = {
          method: "GET",
        }

        const response = await sendRequest(props.token, `coupon/${coupon}/usage?with_model=true`, requestInit)

        if (response.was_used && response?.coupon)
        {
          let coupon_data = response.coupon?.data?.length > 0 ? JSON.parse(response.coupon?.data) : {}

          if(!coupon_data?.freed_domain)
          {
            setCoupon25free(response.was_used)
          }
        }
      } catch (error) {
        console.error('Error check if coupon is used - by-passing beyond coupon check: ',error)
        setCoupon25free(false)
      }
    }

    function postExtendedAttributesData(){
        setLoading(true);
        const data = defineExtendedAttributesData();
        fetch(`${urlDomainRegistry}order/${orderHash()}/item/${extendedAttributesHash()}/extended-attributes`, {
            method: 'POST',
            headers: new Headers({
                'Authorization': `Bearer ${props.token}`,
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(data)
        })
            .then(r => r.json())
            .then(response => {
                if(response.success){
                    if(props.isfromhomepage){
                        window.open(paymentLink(), '_blank');
                        setStep(0);
                    } else {
                        getUsersRegistrationData();
                    }
                }
            })
            .catch(e => {
                console.error('Error post extended attributes data: ',e);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    function postCreateNewUserAccount(){
        setLoading(true);

        var tracking_params = 'p1=rd&p2=https://' + location.hostname + location.search.replace('?', '&');

        if(tracking_params.indexOf("sd=") == -1){
            tracking_params += '&sd=domain-purchase';
        }

        const formData = new FormData();
        formData.append("cadastro_nome", registrationDataForm().first_name + ' ' + registrationDataForm().last_name);
        formData.append("cadastro_email", registrationDataForm().email);
        formData.append("cadastro_telefone_cc", registrationDataForm().country_code);
        formData.append("cadastro_telefone", registrationDataForm().phone);
        formData.append("iubenda_consent", registrationDataForm().iubenda_consent);
        formData.append("tracking_origin", location.hostname);
        formData.append("tracking_params", tracking_params);
        formData.append("send-msu-token", "1");
        formData.append("send-pixel-data", "1");
        formData.append("return_json", "1");

        const requestOptions = {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'include',
            body: formData
        };

        let currentParameters = !urlParameters() ? '' : urlParameters() + '&';
        let currentHash = !urlHash() ? '' : '#' + urlHash();

        fetch(`${urlOffice}/${userLang}/office/create?${currentParameters}tokenreg=${tokenCreateUser + currentHash}`, requestOptions)
            .then((r) => r.json())
            .then((response) => {
                if(response.type == "success"){
                    setErrorMessage(null);
                    props.token = response.user.token;
                    sendPixels(response.user);
                    postBindRegistrationAndOrder();
                } else {
                    setErrorMessage(response.msg);
                }
            })
            .catch(e => {
                console.error('Error post create a new user account: ',e.data.msg);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // Iubenda
    function defineIubenda(){
        _iub.cons_instructions.push(['submit',
            {
                submitElement: buttonRegistrationForm,
                form: {
                    selector: registrationForm,
                    map: {
                        subject: {
                            full_name: 'name',
                            email: 'email'
                        },
                        preferences: {
                            term: 'ba-terms',
                            privacy_policy: 'ba-terms'
                        },
                    }
                },
                consent: {
                    legal_notices: [
                        {
                            identifier: 'terms'
                        },
                        {
                            identifier: 'privacy_policy'
                        },
                        {
                            identifier: 'cookie_policy'
                        }
                    ],
                },
            },
            {
                success: function(res) {
                    let info = res.status == 200 ? res.responseText : JSON.stringify(res);
                    setRegistrationDataForm((prevState) => {
                        return { ...prevState, iubenda_consent: info };
                    });
                    postCreateNewUserAccount();
                },
                error: function(response) {
                    setRegistrationDataForm((prevState) => {
                        return { ...prevState, iubenda_consent: JSON.stringify(response) };
                    });
                    postCreateNewUserAccount();
                }
            }
        ]);
    }

    function baPrivacyPolicy() {
        return {
            us: 'https://www.iubenda.com/privacy-policy/15328257',
            br: 'https://www.iubenda.com/privacy-policy/36736122',
            es: 'https://www.iubenda.com/privacy-policy/19349540',
            it: 'https://www.iubenda.com/privacy-policy/57742374',
            fr: 'https://www.iubenda.com/privacy-policy/12277444',
            de: 'https://www.iubenda.com/privacy-policy/76100068',
            nl: 'https://nl.builderall.com/privacy-policy',
            pl: 'https://pl.builderall.com/polityka-prywatnoci',
            il: 'https://il.builderall.com/privacy-policy'
        }[userLang];
    }

    function baPrivacyPolicyClass() {
        let iubendaLangs = ['us','br','es','it','fr','de','nl'];
        let linkClass    = '';

        if(iubendaLangs.includes(userLang)) {
            linkClass = 'blue-content iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe';
        }

        return linkClass;
    }

    function sendPixels(user){
        const sha1Email = user.pixels.email_sha1;

        /* IMPACT */
        if(user.pixels.impact){
            (function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){
                (e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);}
                )('https://utt.impactcdn.com/A4949573-e6dd-4f6d-8c63-d1bb0a1f71831.js','script','ire',document,window);

            ire('identify', {customerId: user.id, customerEmail: sha1Email});

            // Lead Event
            ire('trackConversion', 41661, {orderId: user.id, ordercustomerId: user.id, customerEmail: sha1Email},{ verifySiteDefinitionMatch: true });

            // Purchase
            var data = {
                orderId: user.id,
                customerId: user.id,
                customerEmail: sha1Email,
                currencyCode: user.pixels.plan.currency,
                orderPromoCode: '',
                orderDiscount: '',
                items: [
                    {
                        subTotal: 0.00,
                        category: 'Plans Trial',
                        sku: user.pixels.plan.id,
                        quantity: 1,
                        name: user.pixels.plan.title
                    }
                ]
            };

            ire('trackConversion', 41662, data,{ verifySiteDefinitionMatch: true });
        }

        /* Google Analytics */
        // If not exist, add that
        if(typeof gtag == 'undefined'){
            var scriptGoogleTagManager = document.createElement('script');
            scriptGoogleTagManager.src = `https://www.googletagmanager.com/gtag/js?id=${user.pixels.analytics.tag}`;
            scriptGoogleTagManager.async = true;
            document.body.appendChild(scriptGoogleTagManager);

            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', user.pixels.analytics.tag);
        }

        // Lead event
        if(user.pixels.analytics.events.lead.execute){
            gtag('event', user.pixels.analytics.events.lead.name, { hitType: 'event', eventAction: 'click'});
        }

        // Trial_purchase event
        if(user.pixels.analytics.events.trial_purchase.execute){
            gtag('event', user.pixels.analytics.events.trial_purchase.name, {
                hitType: 'event',
                eventCategory: 'trial',
                eventAction: 'click',
                currency: user.pixels.analytics.data.currency,
                transaction_id: user.pixels.analytics.data.transaction_id,
                value: 0.00,
                plan: user.pixels.analytics.data.product_title,
                items: [{
                    item_id: user.pixels.analytics.data.product_id,
                    item_name: user.pixels.analytics.data.item_name,
                    currency: user.pixels.analytics.data.currency,
                    price: 0.00,
                    quantity: 1
                }]
            });
        }
    }

    function postBindRegistrationAndOrder(){
        setLoading(true);
        const geralData = {...defineOrderData(), registrant: {...registrationDataForm()}, after_payment_page: urlAfterPaymentPage}

        fetch(`${urlDomainRegistry}order`, {
            method: 'POST',
            headers: new Headers({
                'Authorization': `Bearer ${props.token}`,
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(geralData)
        })
            .then(r => r.json())
            .then(response => {
                if(response.success){
                    let paymentLink = `${urlOffice}/us/office/login?msu-token=${props.token}&redir=${encodeURIComponent(response.data.payment_link)}`;
                    setPaymentLink(paymentLink);
                    setOrderHash(response.data.hash);
                    setExtendedAttributesHash(response.data.items.find(x => x.type == "DOMAIN").hash);
                    validateToExtendedAttributes();
                }
            })
            .catch(e => {
                console.error('Error post order: ',e);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    function postRegistrationData(){
        setLoading(true);

        fetch(`${urlDomainRegistry}registrant`, {
            method: 'POST',
            headers: new Headers({
                'Authorization': `Bearer ${props.token}`,
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(registrationDataForm())
        })
            .then(r => r.json())
            .then(response => {
                if(response.success){
                    setStep(4);
                    getUsersRegistrationData();
                }
            })
            .catch(e => {
                console.error('Error post registration data: ',e);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    function putRegistrationData(){
        setLoading(true);

        fetch(`${urlDomainRegistry}registrant/${registrationDataForm().hash}`, {
            method: 'PUT',
            headers: new Headers({
                'Authorization': `Bearer ${props.token}`,
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(registrationDataForm())
        })
            .then(r => r.json())
            .then(response => {
                if(response.success){
                    setStep(4);
                    getUsersRegistrationData();
                }
            })
            .catch(e => {
                console.error('Error post registration data: ',e);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    function sendOrder(){
        if(props.isfromhomepage){
            setStep(5);
        } else {
            const getDataToOrder = defineOrderData();
            setLoading(true);
            fetch(`${urlDomainRegistry}order`, {
                method: 'POST',
                headers: new Headers({
                    'Authorization': `Bearer ${props.token}`,
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(getDataToOrder)
            })
                .then(r => r.json())
                .then(response => {
                    if(response.success){
                        setOrderHash(response.data.hash);
                        setExtendedAttributesHash(response.data.items.find(x => x.type == "DOMAIN").hash);
                        validateToExtendedAttributes();
                    }
                })
                .catch(e => {
                    console.error('Error post order: ',e);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
    }

    function defineUserRegistrant(){
        if(selectedUserOption() != null){
            setLoading(true);
            let userData = JSON.parse(localStorage.getItem("builderall-appshell--resources"));
            let queryParams = `?noPayment=${coupon25free()}&userId=${userData.user.id}`

            fetch(`${urlDomainRegistry}order/${orderHash()}/registrant/${selectedUserOption().hash}${queryParams}`, {
                method: 'PUT',
                headers: new Headers({
                    'Authorization': `Bearer ${props.token}`,
                    'Content-Type': 'application/json',
                }),
            })
                .then(r => r.json())
                .then(response => {
                    if (response.success)
                    {
                        if (!coupon25free())
                        {
                          window.open(response.data.payment_link, '_blank');
                          setStep(0);
                        }
                        else
                        {
                          sessionStorage.setItem('used-coupon-25free', 'true');
                          alertMsg('ba-success', translations['enom-toast-freed-domain-success']);
                          setStep(1);
                        }
                    }
                })
                .catch(e => {
                    console.error('Error put registration order: ',e);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
    }

    const isEmpty = (val) => {
        return val === 0 || val === undefined || val == null || val.length <= 0 || (typeof val === 'object' && Object.keys(val).length === 0) ? true : false
    }

    const cleanURL = (paramsToRemove) => {
        const urlObj = new URL(window.location.href);
        paramsToRemove.forEach(param => urlObj.searchParams.delete(param));
        window.history.replaceState({ path: urlObj.toString() }, '', urlObj.toString());
    }

    const setStepByParam = async () => {
        const urlParam = new URLSearchParams(window.location.search);
        const paramsToRemove = ['domain-purchase', 'term', 'domain', 'period', 'privacy-protection'];

        setUrlParams({
            domainPurchase: urlParam.get('domain-purchase'),
            term: urlParam.get('term'),
            domain: urlParam.get('domain'),
            period: urlParam.get('period'),
            privacyProtection: urlParam.get('privacy-protection')
        })

        isEmpty(urlParams().domainPurchase) ? null : props.show = true

        switch (urlParams().domainPurchase) {
            case 'funnel-ty':
                setStep(7);
                break;
            case 'start':
                setStep(1);
                break;
            case 'search':
                if (!isEmpty(urlParams().term)) {
                    setStep(2)
                    setSearchFirstDomainValue(urlParams().term);
                    await searchDomain(urlParams().domain);

                    isEmpty(urlParams().period) ? null : setSelectedPeriod(urlParams().period)
                }
                break;
            default:
                break;
        }
        cleanURL(paramsToRemove)
    }

    const openKnowledgebase = () => {
        const data = JSON.parse(localStorage.getItem("builderall-appshell--resources"))
        const lang = data.user.lang.toLowerCase()
        var knowledgebaseUrl = 'https://knowledgebase.builderall.com/'

        if (lang == 'pt_br') {
            knowledgebaseUrl = 'https://ajuda.builderall.com/'
        } else if (lang == 'es_es') {
            knowledgebaseUrl = 'https://kbspanish.builderall.com/'
        }

        window.open(knowledgebaseUrl, '_blank')
    }

    const openHelp = () => {
        const data = JSON.parse(localStorage.getItem("builderall-appshell--resources"))
        const lang = data.user.lang.toLowerCase()
        var knowledgebaseUrl = 'https://knowledgebase.builderall.com/docs/how-to-create-a-website-and-connect-a-domain-in-the-web-builder'

        if (lang == 'pt_br') {
            knowledgebaseUrl = 'https://ajuda.builderall.com/books/configura%C3%A7%C3%B5es-do-site/page/comece-agora-aprenda-como-criar-um-site-e-conectar-seu-dom%C3%ADnio-na-builderall'
        } else if (lang == 'es_es') {
            knowledgebaseUrl = 'https://ayuda.builderall.com/blog/conectar-dominio'
        }

        window.open(knowledgebaseUrl, '_blank')
    }

    onMount(async () => {
        setStepByParam()
    });

    // Components
    function BoxAlert(){
        let status = step() == 2 ? false : true
        const [openAlert, setOpenAlert] = createSignal(status);

        return (
            <div class="alert-information">
                <div class="alert-box">
                    <div class="left-content">
                        <svg width="17" height="16" viewBox="0 0 28 27" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.2991 1.833C12.4524 -0.326496 15.5464 -0.326496 16.6996 1.833L27.3431 21.7445C27.5925 22.2111 27.7168 22.7343 27.7039 23.2632C27.6909 23.7921 27.5412 24.3086 27.2693 24.7624C26.9973 25.2162 26.6125 25.5918 26.1522 25.8527C25.6919 26.1135 25.1719 26.2507 24.6429 26.2508H3.35586C2.82682 26.2507 2.30682 26.1135 1.84654 25.8527C1.38626 25.5918 1.00141 25.2162 0.729474 24.7624C0.45754 24.3086 0.307806 23.7921 0.294862 23.2632C0.281918 22.7343 0.406206 22.2111 0.655614 21.7445L11.2991 1.833ZM13.9994 8.75075C13.6513 8.75075 13.3174 8.88903 13.0713 9.13518C12.8251 9.38132 12.6869 9.71516 12.6869 10.0633V14.4383C12.6869 14.7863 12.8251 15.1202 13.0713 15.3663C13.3174 15.6125 13.6513 15.7508 13.9994 15.7508C14.3475 15.7508 14.6813 15.6125 14.9274 15.3663C15.1736 15.1202 15.3119 14.7863 15.3119 14.4383V10.0633C15.3119 9.71516 15.1736 9.38132 14.9274 9.13518C14.6813 8.88903 14.3475 8.75075 13.9994 8.75075ZM15.7494 19.2508C15.7494 18.7866 15.565 18.3415 15.2368 18.0133C14.9086 17.6851 14.4635 17.5008 13.9994 17.5008C13.5352 17.5008 13.0901 17.6851 12.7619 18.0133C12.4337 18.3415 12.2494 18.7866 12.2494 19.2508C12.2494 19.7149 12.4337 20.16 12.7619 20.4882C13.0901 20.8164 13.5352 21.0008 13.9994 21.0008C14.4635 21.0008 14.9086 20.8164 15.2368 20.4882C15.565 20.16 15.7494 19.7149 15.7494 19.2508Z"/>
                        </svg>
                        <span>{translations["enom-important-information"]}</span>
                    </div>
                    <button classList={{'toggle-alert-btn': true, 'active': openAlert(), 'inactive': !openAlert() }} onClick={() => setOpenAlert(!openAlert())}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                        </svg>
                    </button>
                </div>
                <Show when={openAlert()}>
                    <div class="alert-details">
                        <ol>
                            <li>{translations["enom-alert-info1"]}</li>
                            <li><b>{translations["enom-alert-info-6"]}</b></li>
                            <li>{translations["enom-alert-info2"]}</li>
                            <li>{translations["enom-alert-info3"]}</li>
                            <li>{translations["enom-alert-info4"]}</li>
                            <li>{translations["enom-alert-info5"]}</li>
                            <li>{translations["enom-alert-info7"]}</li>
                        </ol>
                    </div>
                </Show>
            </div>
        )
    }

    // Popups
    function ChooseDomain(){
        return (
            <div class="modal choose-domain">
                <div class="modal-header">
                    <div class="modal-title-box">
                        <span class="modal-title">{translations["enom-choose-the-best-name"]}</span>
                        <button class="modal-close-btn" onclick={() => closeModal()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <g clip-path="url(#clip0_174_1943)">
                                    <path d="M11.5645 0.5C5.52478 0.5 0.628906 5.4247 0.628906 11.5C0.628906 17.5753 5.52478 22.5 11.5645 22.5C17.6043 22.5 22.5001 17.5753 22.5001 11.5C22.5001 5.4247 17.6043 0.5 11.5645 0.5ZM15.6987 14.4915C16.0191 14.8138 16.0191 15.3357 15.6987 15.658C15.5385 15.8197 15.3286 15.9 15.1186 15.9C14.9086 15.9 14.6987 15.8197 14.5385 15.6586L11.5645 12.6666L8.59058 15.658C8.43037 15.8197 8.22041 15.9 8.01044 15.9C7.80048 15.9 7.59051 15.8197 7.43031 15.6586C7.10989 15.3363 7.10989 14.8143 7.43031 14.492L10.4048 11.5L7.43086 8.50855C7.11044 8.18625 7.11044 7.6643 7.43086 7.342C7.75127 7.0197 8.27016 7.0197 8.59058 7.342L11.5645 10.3335L14.5385 7.342C14.8589 7.0197 15.3778 7.0197 15.6982 7.342C16.0186 7.6643 16.0186 8.18625 15.6982 8.50855L12.7242 11.5L15.6987 14.4915Z" fill="#95ACCC"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_174_1943">
                                    <rect width="21.8712" height="22" fill="white" transform="translate(0.628906 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="modal-content">
                    <div class="box-choose-domain">
                        <input type="search" placeholder={translations["enom-search-domain"]} value={searchFirstDomainValue()} onInput={changeSearchDomainInput} on:keydown={handleEnterKey} />
                        <button onClick={() => {validateSearch()}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                            </svg>
                        </button>
                    </div>
                    <Show when={coupon25free()}>
                      <div class="checkbox-box-container">
                        <input
                          name='coupon-checkbox'
                          type='checkbox'
                          class='ba-checkbox checkbox-black-18'
                          checked={useCoupon()}
                          onInput={() => setUseCoupon(!useCoupon())}
                        />
                        <span
                          class='ba-checkbox-label'
                          style={{'color': '#92AAC6'}}
                          onClick={() => setUseCoupon(!useCoupon())}
                        >
                          { translations["enom-use-beyond-freed-domain"] }
                        </span>
                      </div>
                    </Show>
                  <BoxAlert/>
                </div>
            </div>
        );
    }

  function ChooseDomainList() {
    return (
      <div class="modal choose-domain-list">
        <div class="modal-header">
          <div class="modal-title-box">
          <span class="modal-title">{translations["enom-choose-the-best-name"]}</span>
                        <button class="modal-close-btn" onclick={() => closeModal()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <g clip-path="url(#clip0_174_1943)">
                                    <path d="M11.5645 0.5C5.52478 0.5 0.628906 5.4247 0.628906 11.5C0.628906 17.5753 5.52478 22.5 11.5645 22.5C17.6043 22.5 22.5001 17.5753 22.5001 11.5C22.5001 5.4247 17.6043 0.5 11.5645 0.5ZM15.6987 14.4915C16.0191 14.8138 16.0191 15.3357 15.6987 15.658C15.5385 15.8197 15.3286 15.9 15.1186 15.9C14.9086 15.9 14.6987 15.8197 14.5385 15.6586L11.5645 12.6666L8.59058 15.658C8.43037 15.8197 8.22041 15.9 8.01044 15.9C7.80048 15.9 7.59051 15.8197 7.43031 15.6586C7.10989 15.3363 7.10989 14.8143 7.43031 14.492L10.4048 11.5L7.43086 8.50855C7.11044 8.18625 7.11044 7.6643 7.43086 7.342C7.75127 7.0197 8.27016 7.0197 8.59058 7.342L11.5645 10.3335L14.5385 7.342C14.8589 7.0197 15.3778 7.0197 15.6982 7.342C16.0186 7.6643 16.0186 8.18625 15.6982 8.50855L12.7242 11.5L15.6987 14.4915Z" fill="#95ACCC"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_174_1943">
                                    <rect width="21.8712" height="22" fill="white" transform="translate(0.628906 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <builderall-loader loading={loading()} class="modal-content">
                    <div class="box-choose-domain">
                        <input type="search" placeholder={translations["enom-search-domain"]} value={searchFirstDomainValue()} onInput={changeSearchDomainInput} on:keydown={handleEnterKey}/>
                        <button onClick={() => {validateSearch()}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                            </svg>
                        </button>
                    </div>
                    <br />
                    <div class="domains-list">
                        { loading() ? translations["appshell-loading"] : (!loading() && (!domainsList() || domainsList().length == 0) ? translations["appshell-no-records-found"] : '')}
                        <For each={domainsList()}>
                            {(item, index) => (
                                <>
                                    <div classList={{domain: true, active: item.show_details}}>
                                        <div class="domain-line" onClick={() => showDomainDetails(item.domain)}>
                                            <div class="left-content">
                                                <span class="domain-title">{ item.domain }</span>
                                            </div>
                                            <hr class="domain-vertical-line" />
                                            <div class="right-content">
                                                <span class="domain-value">${ item.price.toFixed(2) }</span>
                                                <svg width="24" height="24" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.82943 5.18673C3.72106 5.18519 3.61347 5.20521 3.51291 5.24562C3.41235 5.28603 3.32082 5.34603 3.24365 5.42212C3.16648 5.49821 3.10519 5.58888 3.06337 5.68885C3.02154 5.78883 3 5.89613 3 6.00451C3 6.11288 3.02154 6.22018 3.06337 6.32016C3.10519 6.42014 3.16648 6.51081 3.24365 6.5869C3.32082 6.66299 3.41235 6.72298 3.51291 6.76339C3.61347 6.8038 3.72106 6.82382 3.82943 6.82229H5.33188C5.72874 6.82229 6.05956 7.09647 6.13475 7.48673L6.29554 8.33007C6.29599 8.33256 6.29613 8.33503 6.29661 8.33752L8.05568 17.5716C8.37353 19.241 9.83829 20.4519 11.5376 20.4519H21.746C23.4454 20.4519 24.9085 19.241 25.2269 17.5716L26.986 8.33752C27.0307 8.09873 26.9673 7.85158 26.8124 7.66349C26.657 7.47595 26.4257 7.36747 26.1821 7.36747H17.7317V13.8437L19.0616 12.5137C19.3811 12.1942 19.8985 12.1942 20.218 12.5137C20.5375 12.8327 20.5375 13.3512 20.218 13.6701L17.4921 16.396C17.3329 16.5558 17.1232 16.6356 16.9139 16.6356C16.7045 16.6356 16.4954 16.5558 16.3357 16.396L13.6098 13.6701C13.2903 13.3512 13.2903 12.8327 13.6098 12.5137C13.9292 12.1942 14.4467 12.1942 14.7662 12.5137L16.0961 13.8437V7.36747H7.7767L7.74156 7.18113C7.52178 6.02933 6.50464 5.18673 5.33188 5.18673H3.82943ZM16.0961 7.36747H17.7317V6.54969C17.7317 6.09773 17.3653 5.73191 16.9139 5.73191C16.4625 5.73191 16.0961 6.09773 16.0961 6.54969V7.36747ZM12.825 21.5423C12.3912 21.5423 11.9752 21.7146 11.6685 22.0214C11.3618 22.3281 11.1894 22.7441 11.1894 23.1779C11.1894 23.6116 11.3618 24.0276 11.6685 24.3344C11.9752 24.6411 12.3912 24.8134 12.825 24.8134C13.2588 24.8134 13.6748 24.6411 13.9815 24.3344C14.2882 24.0276 14.4606 23.6116 14.4606 23.1779C14.4606 22.7441 14.2882 22.3281 13.9815 22.0214C13.6748 21.7146 13.2588 21.5423 12.825 21.5423ZM20.4576 21.5423C20.0238 21.5423 19.6078 21.7146 19.3011 22.0214C18.9944 22.3281 18.822 22.7441 18.822 23.1779C18.822 23.6116 18.9944 24.0276 19.3011 24.3344C19.6078 24.6411 20.0238 24.8134 20.4576 24.8134C20.8914 24.8134 21.3074 24.6411 21.6141 24.3344C21.9208 24.0276 22.0932 23.6116 22.0932 23.1779C22.0932 22.7441 21.9208 22.3281 21.6141 22.0214C21.3074 21.7146 20.8914 21.5423 20.4576 21.5423Z"/>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="domain-details">
                                            <Show when={item.id_protection && !coupon25free()}>
                                                <div class="dd-element">
                                                    <span class="dd-subtitle">{translations["enom-add-privacy-protection"]}</span>
                                                    <div class="dd-actions">
                                                        <label class='ba-switch ba-sm'>
                                                            <input type='checkbox' class='ba-checkbox' checked={item.privacy_protection} onInput={() => handleCheckboxChange(item.domain)} />
                                                            <span class='ba-slider'></span>
                                                        </label>
                                                        <span class="dd-privacy-protection-value">+${ parseFloat(servicesList()['price']).toFixed(2) }/{translations["appshell-year"]}</span>
                                                    </div>
                                                </div>
                                            </Show>
                                            <div class="dd-element">
                                              <span
                                                class="dd-subtitle">{translations["enom-registration-length"]}</span>
                                              <div class="dd-actions">
                                                <select class="select-elements" value={selectedPeriod()}
                                                        onChange={(e) => {
                                                          setSelectedPeriod(e.currentTarget.value);
                                                        }}>
                                                  <For each={coupon25free && useCoupon() ? [1] : item.periods}>
                                                    {(item, index) => (
                                                      <>
                                                        <option
                                                          value={item}>{item} {item == 1 ? translations["appshell-year"] : translations["appshell-years"]}</option>
                                                      </>
                                                    )}
                                                  </For>
                                                </select>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </For>
                    </div>
                </builderall-loader>
              <div class="modal-footer">
                <Show when={selectedDomain()}>
                  <span class="selected-domain">{translations["appshell-selected"]}: {selectedDomain()['domain']}</span>
                </Show>
                <Show when={props.isfromhomepage}>
                  <BoxAlert/>
                </Show>
                <div class="right-content">
                  <Show when={selectedDomain()}>
                    <span>{translations["appshell-total"]}: ${calcTotalValue()}</span>
                  </Show>
                  <button class="continue-btn" disabled={!selectedDomain()}
                          onClick={() => sendOrder()}>{translations["appshell-continue"]}</button>
                </div>
              </div>
            </div>
        )
    }

  function AdditionalInformation() {
    return (
      <div class="modal additional-informations">
                <div class="modal-header">
                    <div class="modal-title-box">
                        <span class="modal-title">{translations["enom-additional-information"]}</span>
                        <button class="modal-close-btn" onclick={() => closeModal()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <g clip-path="url(#clip0_174_1943)">
                                    <path d="M11.5645 0.5C5.52478 0.5 0.628906 5.4247 0.628906 11.5C0.628906 17.5753 5.52478 22.5 11.5645 22.5C17.6043 22.5 22.5001 17.5753 22.5001 11.5C22.5001 5.4247 17.6043 0.5 11.5645 0.5ZM15.6987 14.4915C16.0191 14.8138 16.0191 15.3357 15.6987 15.658C15.5385 15.8197 15.3286 15.9 15.1186 15.9C14.9086 15.9 14.6987 15.8197 14.5385 15.6586L11.5645 12.6666L8.59058 15.658C8.43037 15.8197 8.22041 15.9 8.01044 15.9C7.80048 15.9 7.59051 15.8197 7.43031 15.6586C7.10989 15.3363 7.10989 14.8143 7.43031 14.492L10.4048 11.5L7.43086 8.50855C7.11044 8.18625 7.11044 7.6643 7.43086 7.342C7.75127 7.0197 8.27016 7.0197 8.59058 7.342L11.5645 10.3335L14.5385 7.342C14.8589 7.0197 15.3778 7.0197 15.6982 7.342C16.0186 7.6643 16.0186 8.18625 15.6982 8.50855L12.7242 11.5L15.6987 14.4915Z" fill="#95ACCC"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_174_1943">
                                    <rect width="21.8712" height="22" fill="white" transform="translate(0.628906 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                    <p class="modal-subtitle">{translations["enom-domain-extension-selected"]} (.{(selectedDomain().domain).split('.').splice(1).join('.')}). {translations["enom-to-continue-verify-purchase"]}</p>
                </div>
                <div class="modal-content">
                    <form onSubmit={validateExtendedAttributesForm}>
                        <For each={extendedAttributesQuestions()}>
                            {(item, index) => (
                                <>
                                    <div class="input-box-info">
                                        <label for={item.name}>
                                            <span innerHTML={item.description}></span>
                                            <Show when={item.required}>
                                                <span class="required">*</span>
                                            </Show>
                                        </label>
                                        { item.options.length > 0 ? <>
                                            <select class="ba-select ba-md" required={item.required} name={item.name} onChange={(e) => {setValueEA(e.currentTarget.value, item.name);}}>
                                                <option value="">{translations["appshell-select-a-option"]}</option>
                                                <For each={item.options}>
                                                    {(item, index) => (
                                                        <>
                                                            <option value={item.value}>{item.title}</option>
                                                        </>
                                                    )}
                                                </For>
                                            </select>
                                        </> : <>
                                            <input type="text" class="ba-input ba-md" id={item.name} required={item.required} name={item.name} placeholder={translations["appshell-text-goes-here"]} onInput={(e) => setValueEA(e.currentTarget.value, item.name)} />
                                        </>}
                                    </div>
                                    <br />
                                </>
                            )}
                        </For>
                        <div class="modal-footer">
                            <Show
                                when={!props.isfromhomepage}
                                fallback={<div></div>}
                            >
                                <button class="back-btn" onclick={() => {setStep(2)}}>{translations["appshell-back"]}</button>
                            </Show>
                            <button class="continue-btn" type="submit">{translations["appshell-continue"]}</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    function RegistrationData(){
        return (
            <div class="modal registration-data">
                <div class="modal-header">
                    <div class="modal-title-box">
                        <span class="modal-title">{translations["enom-registration-data"]}</span>
                        <button class="modal-close-btn" onclick={() => closeModal()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <g clip-path="url(#clip0_174_1943)">
                                    <path d="M11.5645 0.5C5.52478 0.5 0.628906 5.4247 0.628906 11.5C0.628906 17.5753 5.52478 22.5 11.5645 22.5C17.6043 22.5 22.5001 17.5753 22.5001 11.5C22.5001 5.4247 17.6043 0.5 11.5645 0.5ZM15.6987 14.4915C16.0191 14.8138 16.0191 15.3357 15.6987 15.658C15.5385 15.8197 15.3286 15.9 15.1186 15.9C14.9086 15.9 14.6987 15.8197 14.5385 15.6586L11.5645 12.6666L8.59058 15.658C8.43037 15.8197 8.22041 15.9 8.01044 15.9C7.80048 15.9 7.59051 15.8197 7.43031 15.6586C7.10989 15.3363 7.10989 14.8143 7.43031 14.492L10.4048 11.5L7.43086 8.50855C7.11044 8.18625 7.11044 7.6643 7.43086 7.342C7.75127 7.0197 8.27016 7.0197 8.59058 7.342L11.5645 10.3335L14.5385 7.342C14.8589 7.0197 15.3778 7.0197 15.6982 7.342C16.0186 7.6643 16.0186 8.18625 15.6982 8.50855L12.7242 11.5L15.6987 14.4915Z" fill="#95ACCC"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_174_1943">
                                    <rect width="21.8712" height="22" fill="white" transform="translate(0.628906 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <builderall-loader loading={loading()} class="modal-content">
                    <For each={usersRegistrationData()}>
                        {(item, index) => (
                            <>
                                <div onClick={() => defineSelectedUser(item)} classList={{'registration': true, 'active':  selectedUserOption() != null && selectedUserOption().hash == item.hash}}>
                                    <div class="info-top">
                                        <div class="left-content">
                                            <span class="info-name">{item.first_name} {item.last_name}</span>
                                            <hr class="info-vertical-line" />
                                            <span class="info-phone">(+{item.country_code}) {item.phone}</span>
                                        </div>
                                        <button class="info-edit-btn" onclick={() => {defineSelectedUser(item); editRegistrationData(item)}}>{translations["appshell-edit"]}</button>
                                    </div>
                                    <div class="info-main">
                                        <div class="info-geral">
                                            <span><b>{translations["appshell-address"]}:</b> {item.address}</span>
                                            <span><b>{translations["appshell-city"]}:</b> {item.city}</span>
                                            <span><b>{translations["appshell-state-province"]}:</b> {item.state_province}</span>
                                            <span><b>{translations["appshell-country"]}:</b> {item.country}</span>
                                        </div>
                                        <span class="info-terms-accept">{translations["appshell-terms-accepted-on"]} {fixCreatedAtDate(item.created_at)}</span>
                                    </div>
                                </div>
                                <br />
                            </>
                        )}
                    </For>
                    <button class="info-new-registration-btn" onclick={() => {setStep(5); resetRegistrationData();}}>{translations["appshell-add-new"]}</button>
                </builderall-loader>
                <div class="modal-footer">
                    <button class="back-btn" onclick={validateBackToExtendedAttributes}>{translations["appshell-back"]}</button>
                    <button class="continue-btn" disabled={!selectedUserOption()} onclick={() => {defineUserRegistrant();}}>{translations["appshell-continue"]}</button>
                </div>
            </div>
        );
    }

    function RegistrationDataForm(){
        return (
            <div class="modal registration-data-form">
                <div class="modal-header">
                    <div class="modal-title-box">
                        <span class="modal-title">{translations["enom-registration-data"]}</span>
                        <button class="modal-close-btn" onclick={() => closeModal()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <g clip-path="url(#clip0_174_1943)">
                                    <path d="M11.5645 0.5C5.52478 0.5 0.628906 5.4247 0.628906 11.5C0.628906 17.5753 5.52478 22.5 11.5645 22.5C17.6043 22.5 22.5001 17.5753 22.5001 11.5C22.5001 5.4247 17.6043 0.5 11.5645 0.5ZM15.6987 14.4915C16.0191 14.8138 16.0191 15.3357 15.6987 15.658C15.5385 15.8197 15.3286 15.9 15.1186 15.9C14.9086 15.9 14.6987 15.8197 14.5385 15.6586L11.5645 12.6666L8.59058 15.658C8.43037 15.8197 8.22041 15.9 8.01044 15.9C7.80048 15.9 7.59051 15.8197 7.43031 15.6586C7.10989 15.3363 7.10989 14.8143 7.43031 14.492L10.4048 11.5L7.43086 8.50855C7.11044 8.18625 7.11044 7.6643 7.43086 7.342C7.75127 7.0197 8.27016 7.0197 8.59058 7.342L11.5645 10.3335L14.5385 7.342C14.8589 7.0197 15.3778 7.0197 15.6982 7.342C16.0186 7.6643 16.0186 8.18625 15.6982 8.50855L12.7242 11.5L15.6987 14.4915Z" fill="#95ACCC"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_174_1943">
                                    <rect width="21.8712" height="22" fill="white" transform="translate(0.628906 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <Show when={props.isfromhomepage}>
                    <a
                        class="already-have-account"
                        href={`${urlOffice}/${userLang}/office/?domain-purchase=search&term=${searchFirstDomainValue()}&domain=${selectedDomain().domain}&period=${selectedPeriod()}${selectedDomain().privacy_protection ? '&privacy-protection=1' : ''}`}
                    >{translations["appshell-already-have-account"]} <b>{translations["appshell-login"]}</b></a>
                </Show>
                <builderall-loader loading={loading()} class="modal-content">
                    <form ref={setRegistrationForm} onSubmit={validateRegistrationDataForm}>
                        <div class="two-elements">
                            <div class="input-box-info">
                                <label for="name">
                                    {translations["appshell-name"]}
                                    <span class="required">*</span>
                                </label>
                                <input type="text" id="name" name="name" class="ba-input" pattern="[\x20-\x7E]+" required placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().first_name} onInput={(event) => changeRegistrationInput(event, 'first_name')} />
                            </div>
                            <div class="input-box-info">
                                <label for="last-name">
                                    {translations["appshell-last-name"]}
                                    <span class="required">*</span>
                                </label>
                                <input type="text" id="last-name" class="ba-input" pattern="[\x20-\x7E]+" required placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().last_name} onInput={(event) => changeRegistrationInput(event, 'last_name')} />
                            </div>
                        </div>
                        <div class="input-box-info">
                            <label for="address">
                                {translations["appshell-address"]}
                                <span class="required">*</span>
                            </label>
                            <input type="text" id="address" class="ba-input" pattern="[\x20-\x7E]+" required placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().address} onInput={(event) => changeRegistrationInput(event, 'address')} />
                        </div>
                        <div class="input-box-info">
                            <label for="address2">
                                {translations["appshell-address-complement"]}
                            </label>
                            <input type="text" id="address2" class="ba-input" pattern="[\x20-\x7E]+" placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().address_complement} onInput={(event) => changeRegistrationInput(event, 'address_complement')} />
                        </div>
                        <div class="three-elements">
                            <div class="input-box-info">
                                <label for="city">
                                    {translations["appshell-city"]}
                                    <span class="required">*</span>
                                </label>
                                <input type="text" id="city" class="ba-input" pattern="[\x20-\x7E]+" required placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().city} onInput={(event) => changeRegistrationInput(event, 'city')} />
                            </div>
                            <div class="input-box-info">
                                <label for="state-province">
                                    {translations["appshell-province-choice"]}
                                    <span class="required">*</span>
                                </label>
                                <select class="ba-select ba-md" required value={registrationDataForm().state_province_choice} onInput={(event) => changeRegistrationInput(event, 'state_province_choice')}>
                                    <option value="STATE">{translations["appshell-state"]}</option>
                                    <option value="PROVINCE">{translations["appshell-province"]}</option>
                                </select>
                            </div>
                            <div class="input-box-info">
                                <label for="state">
                                    {translations["appshell-state-province"]}
                                    <span class="required">*</span>
                                </label>
                                <input type="text" id="state" pattern="[\x20-\x7E]+" classList={{"ba-input": true, "ba-error": registrationDataForm().state_province && registrationDataForm().state_province.length > 2}} required placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().state_province} onInput={(event) => changeRegistrationInput(event, 'state_province')}  />
                                <span class="validation-text">{ registrationDataForm().state_province && registrationDataForm().state_province.length > 2 ? translations["appshell-max-2-characters"] : '' }</span>
                            </div>
                        </div>
                        <div class="two-elements">
                            <div class="input-box-info">
                                <label for="postal-code">
                                    {translations["appshell-postal-code"]}
                                    <span class="required">*</span>
                                </label>
                                <input type="text" id="postal-code" pattern="[\x20-\x7E]+" class="ba-input" required placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().postal_code} onInput={(event) => changeRegistrationInput(event, 'postal_code')} />
                            </div>
                            <div class="input-box-info">
                                <label for="country">
                                    {translations["appshell-country"]}
                                    <span class="required">*</span>
                                </label>
                                <select class='ba-select ba-md text-capitalize' id="country" required value={registrationDataForm().country} onChange={(event) => {changeRegistrationInput(event, 'country');}}>
                                    <For each={countryCodes}>
                                        {(item, index) => (
                                            <>
                                                <option value={item.country}>{item.name}</option>
                                            </>
                                        )}
                                    </For>
                                </select>
                            </div>
                        </div>
                        <div class="input-box-info">
                            <label for="email">
                                {translations["appshell-email-address"]}
                                <span class="required">*</span>
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                classList={{'ba-input': true, 'ba-error': errorMessage() && errorMessage().includes('email')}}
                                required
                                placeholder={translations["appshell-text-goes-here"]}
                                value={registrationDataForm().email}
                                onInput={(event) => {
                                    changeRegistrationInput(event, 'email');
                                    setErrorMessage(null);
                                }}
                            />
                            <span class="validation-text">{ errorMessage() && errorMessage().includes('email') ? errorMessage() : '' }</span>
                        </div>
                        <div class="input-box-info">
                            <label for="phone">
                                {translations["appshell-phone"]}
                                <span class="required">*</span>
                            </label>
                            <div class='ba-box-input-with-element'>
                                <select class='ba-bi-element' required value={registrationDataForm().country_code} onChange={(event) => {changeRegistrationInput(event, 'country_code');}}>
                                    <For each={countryCodes}>
                                        {(item, index) => (
                                            <>
                                                <option value={item.code}>+{item.code}</option>
                                            </>
                                        )}
                                    </For>
                                </select>
                                <div class='ba-bi-box-input'>
                                    <input type="tel" id="phone" required placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().phone} onInput={(event) => changeRegistrationInput(event, 'phone')} />
                                </div>
                            </div>
                        </div>
                        <div class="input-box-info">
                            <label for="jobtitle">
                                {translations["appshell-organization-name"]}
                                <Show when={registrationDataForm().job_title}>
                                    <span class="required">*</span>
                                </Show>
                            </label>
                            <input type="text" pattern="[\x20-\x7E]+" id="jobtitle" class="ba-input" required={registrationDataForm().job_title} placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().organization} onInput={(event) => changeRegistrationInput(event, 'organization')} />
                        </div>
                        <div class="input-box-info">
                            <label for="organization">
                                {translations["appshell-job-title"]}
                                <Show when={registrationDataForm().organization}>
                                    <span class="required">*</span>
                                </Show>
                            </label>
                            <input type="text" pattern="[\x20-\x7E]+" id="organization" class="ba-input" required={registrationDataForm().organization} placeholder={translations["appshell-text-goes-here"]} value={registrationDataForm().job_title} onInput={(event) => changeRegistrationInput(event, 'job_title')} />
                        </div>
                        <div class="checkbox-box">
                            <input type="checkbox" id="terms" checked={registrationDataForm().accept_terms} onInput={(event) => changeRegistrationInput(event, 'accept_terms')} required />
                            <label for="terms">
                                {translations["appshell-i-accept-the"]} <a href="https://api.enom.com/docs/GetAgreementPage" target="_blank" class="blue-content">{translations["appshell-terms-of-use"]}</a>
                                <span class="required"> *</span>
                            </label>
                        </div>
                        <Show when={props.isfromhomepage}>
                            <div class="checkbox-box">
                                <input type="checkbox" id="ba-terms" name="ba-terms" checked={registrationDataForm().accept_ba_terms} onInput={(event) => changeRegistrationInput(event, 'accept_ba_terms')} required={props.isfromhomepage} />
                                <label for="ba-terms">
                                    {translations["appshell-ba-terms-1"]} <a href="https://builderall.com/terms-of-use" target="_blank" class="blue-content">{translations["appshell-single-terms-of-use"]}</a> {translations["appshell-and"]} <a href={baPrivacyPolicy()} target="_blank" class={baPrivacyPolicyClass()}>{translations["appshell-privacy-policy"]}</a>, {translations["appshell-ba-terms-2"]}
                                    <span class="required"> *</span>
                                </label>
                            </div>
                        </Show>
                        <Show when={errorMessage()}>
                            <div class='ba-alert ba-error'>
                                <span>{errorMessage().includes('email') ? translations["appshell-complete-the-fields-correctly"] : errorMessage()}</span>
                            </div>
                        </Show>
                        <div class="modal-footer">
                            <button class="back-btn" onclick={validateBackToRegistrationDataList}>{translations["appshell-back"]}</button>
                            <button class="continue-btn" ref={setButtonRegistrationForm} type="submit">{translations["appshell-continue"]}</button>
                        </div>
                    </form>
                </builderall-loader>
            </div>
        );
    }

    function ThankYou(){
        return (
            <div class="modal thank-you-modal">
                <div class="modal-header">
                    <div class="modal-title-box">
                        <div></div>
                        <span class="modal-title">{translations["enom-thank-you-for-purchase"]}</span>
                        <button class="modal-close-btn" onclick={() => closeModal()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <g clip-path="url(#clip0_174_1943)">
                                    <path d="M11.5645 0.5C5.52478 0.5 0.628906 5.4247 0.628906 11.5C0.628906 17.5753 5.52478 22.5 11.5645 22.5C17.6043 22.5 22.5001 17.5753 22.5001 11.5C22.5001 5.4247 17.6043 0.5 11.5645 0.5ZM15.6987 14.4915C16.0191 14.8138 16.0191 15.3357 15.6987 15.658C15.5385 15.8197 15.3286 15.9 15.1186 15.9C14.9086 15.9 14.6987 15.8197 14.5385 15.6586L11.5645 12.6666L8.59058 15.658C8.43037 15.8197 8.22041 15.9 8.01044 15.9C7.80048 15.9 7.59051 15.8197 7.43031 15.6586C7.10989 15.3363 7.10989 14.8143 7.43031 14.492L10.4048 11.5L7.43086 8.50855C7.11044 8.18625 7.11044 7.6643 7.43086 7.342C7.75127 7.0197 8.27016 7.0197 8.59058 7.342L11.5645 10.3335L14.5385 7.342C14.8589 7.0197 15.3778 7.0197 15.6982 7.342C16.0186 7.6643 16.0186 8.18625 15.6982 8.50855L12.7242 11.5L15.6987 14.4915Z" fill="#95ACCC"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_174_1943">
                                    <rect width="21.8712" height="22" fill="white" transform="translate(0.628906 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="modal-content">
                    <span class="modal-main-span">{translations["enom-payment-is-processing"]}</span>
                    <span><b>{translations["enom-alert-info-6"]}</b></span>
                    <div class="modal-main-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="184" height="185" viewBox="0 0 184 185" fill="none">
                            <path d="M184 92.5C184 140.005 147.995 179.126 101.78 183.963C98.5561 184.393 95.2243 184.5 92 184.5C44.6028 184.5 5.58879 148.71 0.537383 102.603C0.107476 99.271 0 95.9393 0 92.5C0 41.6635 41.1635 0.5 92 0.5C142.836 0.5 184 41.6635 184 92.5Z" fill="#FFCD52"/>
                            <path d="M143.267 138.93L101.888 183.962C98.6637 184.392 95.3319 184.5 92.1076 184.5C44.7104 184.5 5.69642 148.71 0.64502 102.603L43.3132 54.5605L143.267 138.93Z" fill="#F7B93C"/>
                            <path d="M131.874 63.6954V106.579C131.874 113.35 126.392 118.831 119.621 118.831H51.2663C44.4952 118.831 39.0139 113.35 39.0139 106.579V63.6954C39.0139 56.9244 44.4952 51.4431 51.2663 51.4431H119.621C126.392 51.4431 131.874 56.9244 131.874 63.6954Z" fill="white"/>
                            <path d="M131.874 63.6954H39.1213C39.1213 56.9244 44.6027 51.4431 51.3737 51.4431H119.729C126.5 51.4431 131.981 56.9244 131.981 63.6954H131.874Z" fill="#00A7A4"/>
                            <path d="M85.3365 108.083C75.9861 108.083 67.7104 101.42 65.7758 92.2843C65.5608 91.3171 66.2057 90.2423 67.173 90.0273C68.1403 89.8124 69.215 90.4572 69.43 91.4245C71.0421 98.8404 77.7057 104.214 85.3365 104.214C94.2571 104.214 101.566 96.9058 101.566 87.9853C101.566 79.0647 94.2571 71.7563 85.3365 71.7563C80.3926 71.7563 75.7711 73.9058 72.7618 77.775C72.1169 78.6348 70.9347 78.7423 70.0749 78.0974C69.3225 77.4526 69.1076 76.2703 69.7524 75.4105C73.6216 70.6815 79.2104 67.9946 85.3365 67.9946C96.4066 67.9946 105.327 76.9152 105.327 87.9853C105.327 99.0554 96.4066 107.976 85.3365 107.976V108.083Z" fill="#C24742"/>
                            <path d="M69.5374 80.8918C69.5374 80.8918 68.7851 80.7844 68.4626 80.5694C68.0327 80.247 67.7103 79.8171 67.7103 79.2797C67.0654 73.476 67.0654 73.261 67.0654 73.1535C67.0654 72.0788 67.9252 71.3264 68.8925 71.3264C69.8598 71.3264 70.7196 72.0788 70.7196 73.1535C70.7196 73.4759 70.9346 75.4105 71.1495 76.9152L74.8037 76.1629C75.771 75.9479 76.8458 76.5928 77.0608 77.6675C77.2757 78.6348 76.6308 79.7096 75.5561 79.9246L69.8598 81.1068C69.8598 81.1068 69.6449 81.1068 69.4299 81.1068L69.5374 80.8918Z" fill="#C24742"/>
                            <path d="M140.902 103.784H91.7852C89.589 103.784 87.8086 105.565 87.8086 107.761V136.457C87.8086 138.653 89.589 140.434 91.7852 140.434H140.902C143.098 140.434 144.879 138.653 144.879 136.457V107.761C144.879 105.565 143.098 103.784 140.902 103.784Z" fill="#00A7A4"/>
                            <path d="M144.879 127.214H87.8086V132.373H144.879V127.214Z" fill="white"/>
                            <path d="M136.71 113.242C138.016 113.242 139.075 112.184 139.075 110.878C139.075 109.572 138.016 108.513 136.71 108.513C135.404 108.513 134.346 109.572 134.346 110.878C134.346 112.184 135.404 113.242 136.71 113.242Z" fill="#C24742"/>
                            <path d="M134.346 113.457C132.949 113.457 131.766 112.275 131.766 110.878C131.766 109.481 132.949 108.298 134.346 108.298C135.743 108.298 136.925 109.481 136.925 110.878C136.925 112.275 135.743 113.457 134.346 113.457ZM134.346 108.728C133.164 108.728 132.196 109.696 132.196 110.878C132.196 112.06 133.164 113.027 134.346 113.027C135.528 113.027 136.495 112.06 136.495 110.878C136.495 109.696 135.528 108.728 134.346 108.728Z" fill="white"/>
                            <path d="M101.673 108.406H95.3319C94.9164 108.406 94.5796 108.719 94.5796 109.104C94.5796 109.49 94.9164 109.803 95.3319 109.803H101.673C102.089 109.803 102.425 109.49 102.425 109.104C102.425 108.719 102.089 108.406 101.673 108.406Z" fill="white"/>
                            <path d="M106.51 111.738H95.3319C94.9164 111.738 94.5796 112.05 94.5796 112.436C94.5796 112.822 94.9164 113.135 95.3319 113.135H106.51C106.925 113.135 107.262 112.822 107.262 112.436C107.262 112.05 106.925 111.738 106.51 111.738Z" fill="white"/>
                            <path d="M57.3925 44.5647H53.3084C52.4181 44.5647 51.6963 45.2865 51.6963 46.1768V56.817C51.6963 57.7074 52.4181 58.4292 53.3084 58.4292H57.3925C58.2829 58.4292 59.0047 57.7074 59.0047 56.817V46.1768C59.0047 45.2865 58.2829 44.5647 57.3925 44.5647Z" fill="white"/>
                            <path d="M117.58 44.5647H113.496C112.605 44.5647 111.884 45.2865 111.884 46.1768V56.817C111.884 57.7074 112.605 58.4292 113.496 58.4292H117.58C118.47 58.4292 119.192 57.7074 119.192 56.817V46.1768C119.192 45.2865 118.47 44.5647 117.58 44.5647Z" fill="white"/>
                        </svg>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="continue-btn" onclick={() => closeModal()}>{translations["appshell-continue"]}</button>
                </div>
            </div>
        );
    }

    function WelcomeNewAccount(){
        const [createImage] = createSignal(CreateImg);
        const [domainImage] = createSignal(DomainImg);
        const [upgradeImage] = createSignal(UpgradeImg);

        return (
            <div className="modal welcome-modal">
                <div className="modal-header">
                    <div className="modal-title-box">
                        <div className="header-title--center ba-w-100">
                            <span className="modal-title">{translations['welcome-new-account']}</span>
                            <span className="modal-subtitle">{translations['you-just-new-domain']}</span>
                            <span className="modal-subtitle" innerHTML={translations['access-free-trial']}></span>
                        </div>
                        <button className="modal-close-btn" onClick={() => closeModal()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23"
                                 fill="none">
                                <g clip-path="url(#clip0_174_1943)">
                                    <path
                                        d="M11.5645 0.5C5.52478 0.5 0.628906 5.4247 0.628906 11.5C0.628906 17.5753 5.52478 22.5 11.5645 22.5C17.6043 22.5 22.5001 17.5753 22.5001 11.5C22.5001 5.4247 17.6043 0.5 11.5645 0.5ZM15.6987 14.4915C16.0191 14.8138 16.0191 15.3357 15.6987 15.658C15.5385 15.8197 15.3286 15.9 15.1186 15.9C14.9086 15.9 14.6987 15.8197 14.5385 15.6586L11.5645 12.6666L8.59058 15.658C8.43037 15.8197 8.22041 15.9 8.01044 15.9C7.80048 15.9 7.59051 15.8197 7.43031 15.6586C7.10989 15.3363 7.10989 14.8143 7.43031 14.492L10.4048 11.5L7.43086 8.50855C7.11044 8.18625 7.11044 7.6643 7.43086 7.342C7.75127 7.0197 8.27016 7.0197 8.59058 7.342L11.5645 10.3335L14.5385 7.342C14.8589 7.0197 15.3778 7.0197 15.6982 7.342C16.0186 7.6643 16.0186 8.18625 15.6982 8.50855L12.7242 11.5L15.6987 14.4915Z"
                                        fill="#95ACCC"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_174_1943">
                                        <rect width="21.8712" height="22" fill="white"
                                              transform="translate(0.628906 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="modal-content">
                    <div className="box-welcome-modal">
                        <div className="content-card">
                            <div className="top">
                                <span className="content-card--title">{translations['create-and-connect']}</span>
                                <span className="content-card--subtitle">{translations['create-and-connect-desc']}</span>
                            </div>
                            <div className="bottom">
                                <img className="welcome-svg" src={createImage()}/>
                                <button onClick={() => openHelp()} className="welcome-button">{translations['watch-tutorial']}</button>
                            </div>
                        </div>
                        <div className="content-card">
                            <div className="top">
                                <span className="content-card--title">{translations['plan-upgrade']}</span>
                                <span className="content-card--subtitle">{translations['plan-upgrade-desc']}</span>
                            </div>
                            <div className="bottom">
                                <img className="welcome-svg" src={upgradeImage()}/>
                                <button onClick={() => {window.open('https://checkout.builderall.com/plans', '_blank')}} className="welcome-button">{translations['see-plans']}</button>
                            </div>
                        </div>
                        <div className="content-card">
                            <div className="top">
                                <span className="content-card--title">{translations['external-domain']}</span>
                                <span className="content-card--subtitle">{translations['external-domain-desc']}</span>
                            </div>
                            <div className="bottom">
                                <img className="welcome-svg" src={domainImage()}/>
                                <button onClick={() => {window.open('https://office.builderall.com/us/office/support-system/support', '_blank')}} className="welcome-button">{translations['talk-to-support']}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer ba-w-100">
                    <span onClick={() => openKnowledgebase()} innerHTML={translations['access-knowledgebase']}></span>
                </div>
            </div>
        );
    }

    return (
        <>
          <style>{require("bundle-text:./styles/ba-toast.scss")}</style>

          <Show when={props.show}>
            <style>{require("bundle-text:./styles/index.scss")}</style>
          </Show>

          <div class="modal-backdrop enom-modal" onMouseDown={verifyToCloseModal}>
            <Show when={props.show}>
              {step() === 0 ? closeModal() : ''}
              {step() === 1 && <ChooseDomain />}
              {step() === 2 && <ChooseDomainList />}
              {step() === 3 && <AdditionalInformation />}
              {step() === 4 && <RegistrationData />}
              {step() === 5 && <RegistrationDataForm />}
              {step() === 6 && <ThankYou />}
              {step() === 7 && <WelcomeNewAccount />}
            </Show>

            <div class={`ba-toast ${toastData().type} ${showToast() ? "show" : "hide"}`}>
              <div class='ba-toast-alert'>
                <div class='ba-left'>
                  <span class='ba-icon'></span>
                  <Show when={!isEmpty(toastData().url)} fallback={
                    <span class='ba-text'>{toastData().message}</span>
                  }>
                    <a href={toastData().url} class='ba-text'>{toastData().message}</a>
                  </Show>
                </div>
                <span onClick={() => closeToast()} class='ba-close-btn'></span>
              </div>
            </div>
          </div>
        </>
    );
});
